import React from 'react'

import Map from '@components/GymSearchMap'

import {
  BrokerGymMarker,
  BrokerGymMarkerSelected,
  BrokerSearch,
  BrokerFilter,
  BrokerAim,
  BrokerZoomIn,
  BrokerZoomOut,
} from '@assets/icons'
import MapWrapper from './GymSearchMap.style'

function GymSearchMap() {
  const icons = {
    gymMarker: BrokerGymMarker,
    gymMarkerSelected: BrokerGymMarkerSelected,
    search: BrokerSearch,
    filter: BrokerFilter,
    aim: BrokerAim,
    zoomIn: BrokerZoomIn,
    zoomOut: BrokerZoomOut,
  }

  const theme = {
    searchInArea: {
      buttonText: {
        color: '#d8385e;',
      },
    },
    planCard: {
      description: {
        color: '#231b22;',
      },
      price: {
        color: '#d8385e;',
        iconColor: '#d8385e;',
      },
      buttonOutline: {
        borderColor: '#d8385e;',
        border: '2px solid #d8385e;',
        color: '#d8385e;',
        focus: {
          backgroundColor: 'rgba(216, 56, 94, 0.3) !important;',
        },
        hover: {
          backgroundColor: 'rgba(216, 56, 94, 0.3) !important;',
        },
        active: {
          borderColor: '#d8385e !important;',
          backgroundColor: '#ffffff !important;',
          border: '2px solid #d8385e !important;',
          color: '#d8385e !important;',
        },
      },
    },
    planSelector: {
      planSelectorItem: {
        span: {
          backgroundColor: '#d8385e;',
        },
      },
    },
  }

  return (
    <MapWrapper>
      <Map icons={icons} theme={theme} />
    </MapWrapper>
  )
}

export default GymSearchMap
